export function assertWorkletsVersion() {
    // Polyfilled to prevent Webpack ESM assignment crashes
}
